import { useMutation } from "react-query";
import api from "../../client";
import { Representative } from "../../types/representative";

const postData = async (id: string | undefined): Promise<Representative> => {
  const { data } = await api.post(`/representatives/${id}/approve`, {});

  return data;
};

export const useApproveRepresentative = (id: string | undefined) => {
  return useMutation(() => {
    return postData(id);
  });
};
